import { render } from "./MPromotionDetails.vue?vue&type=template&id=53e1a9ae&scoped=true"
import script from "./MPromotionDetails.vue?vue&type=script&lang=js"
export * from "./MPromotionDetails.vue?vue&type=script&lang=js"

import "./MPromotionDetails.vue?vue&type=style&index=0&id=53e1a9ae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e1a9ae"]])

export default __exports__